import * as o from "react";
import m from "../lib/SSRBase.es.js";
import e from "../defs/InstagramLogo.es.js";
const a = o.forwardRef((r, t) => /* @__PURE__ */ o.createElement(m, { ref: t, ...r, weights: e }));
a.displayName = "InstagramLogoIcon";
const g = a;
export {
  g as InstagramLogo,
  a as InstagramLogoIcon
};
